import gql from 'graphql-tag';

export const SEARCH_MOODS = gql`
  query searchMoods ($idValue: String!) {
    SearchMoods(name:$idValue) {
      id,
      name
    }
  }
`;

export const GET_MOOD = gql`
  query getMood(
    $id: ID,
    $name: String
  ) {
    Mood(
      id: $id,
      name: $name
    ){
      id,
      name,
      mainMood {
        id,
        name
      }
      subMoods {
        id,
        name
      }
      components {
        id,
        title,
        __typename
      }
    }
}
`;

export const CREATE_MOOD = gql`
  mutation createMood(
  $id: ID,
  $name: String
) {
  CreateMood(
    id: $id,
    name: $name
  ){
    id,
    name
  }
}
`;

export const UPDATE_MOOD = gql`
  mutation updateMood(
  $id: ID!,
  $name: String
) {
  UpdateMood(
    id: $id,
    name: $name
  ){
    id,
    name
  }
}
`;

export const DELETE_MOOD = gql`
  mutation deleteMood (
    $id: ID!
  ) {
  DeleteMood(
    id: $id
  ) {
    id
  }
}
`;

// AddMoodSubMoods(from: _MoodInput!, to: _MoodInput!): _AddMoodSubMoodsPayload
// RemoveMoodSubMoods(
//   from: _MoodInput!
//   to: _MoodInput!
// ): _RemoveMoodSubMoodsPayload
// AddMoodMainMood(from: _MoodInput!, to: _MoodInput!): _AddMoodMainMoodPayload
// RemoveMoodMainMood(
//   from: _MoodInput!
//   to: _MoodInput!
// ): _RemoveMoodMainMoodPayload
